import { useCallback } from 'react'
//
import { fetchPostAdEvent, SchemaOholoMaterialShow } from 'api'
import { Image } from './Styled'
import { formatDate } from 'utils/timeFormat'

interface CarouselItemProps extends SchemaOholoMaterialShow {
  noLazy?: boolean
  allowUnload?: boolean
}

export default function CarouselItem({ noLazy, allowUnload = false, ...info }: CarouselItemProps) {
  const onItemClick = useCallback(() => {
    if (info) {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: info.id,
        material_name: info.name,
        oholo_site_id: info.site_type,
        oholoer_id: info.oholoer_id,
        oholoer_link: info.oholoer_link,
        oholoer_name: info.oholoer_name,
      })
      window.open(info?.link, '_blank')
    } else {
      console.warn('no ad assigned')
    }
  }, [info])

  return <Image src={info.icon_path} noLazy={noLazy} onClick={onItemClick} allowUnload={allowUnload} />
}
